import { computed, provide, readonly } from 'vue';
import { allThemes } from './themes/component-lib.esm.js';
import { headCss } from '../component-lib.esm5.js';
import { getThemeCSSVariables } from '../component-lib.esm3.js';
import { globalCss } from '../component-lib.esm4.js';
const availableThemes = allThemes.reduce((accum, curr) => {
  accum[curr.name] = curr;
  return accum;
}, {});
function getCurrentTheme(theme) {
  if (typeof theme === 'string') {
    return availableThemes[theme];
  }
  return theme;
}

/**
 * Inject the provided theme into the page
 * Can also inject CSS variables
 */
const ThemeProvider = {
  props: {
    theme: {
      type: [String, Object],
      required: true
    },
    /**
     * Inject CSS variables into a wrapper element, instead of the head
     */
    injectLocally: Boolean
  },
  head() {
    if (this.injectLocally) return null;
    return {
      style: [headCss(this.currentTheme), globalCss()],
      __dangerouslyDisableSanitizersByTagID: {
        'head-css': ['innerHTML']
      }
    };
  },
  setup(props) {
    const themeObject = computed(() => {
      return getCurrentTheme(props.theme);
    });
    const themeCSSVariables = computed(() => {
      return getThemeCSSVariables(themeObject.value);
    });
    provide('currentTheme', readonly(themeObject));
    return {
      currentTheme: themeObject,
      themeCSSVariables
    };
  },
  render(h) {
    if (this.injectLocally) {
      return h('div', {
        class: 'theme-provider',
        style: this.themeCSSVariables
      }, [this.$slots.default]);
    }
    return this.$slots.default;
  }
};
export { ThemeProvider, getCurrentTheme };